import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './style.module.scss';
export default function Switch({ isOn, onToggle }) {
    return (_jsxs("label", { className: styles.switch, children: [_jsx("input", { type: "checkbox", checked: isOn, onChange: (e) => onToggle(e.target.checked) }), _jsx("span", { className: styles['switch-track'], style: isOn ? { background: 'var(--savings)' } : {} })] }));
}
